import { MapPin, Clock, Navigation } from "lucide-react";
import { RESTAURANT } from "@/data/restaurant";

export default function LocationSection() {
  return (
    <section
      id="location"
      data-testid="location-section"
      className="py-20 sm:py-28 bg-[#2C2825] text-[#F9F6F0]"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5 reveal">
          <p className="text-[#F2B441] text-xs font-semibold tracking-[0.25em] uppercase">
            Find us
          </p>
          <h2 className="mt-3 font-display text-4xl sm:text-5xl font-extrabold tracking-tight leading-tight">
            Right in the heart of Awka.
          </h2>

          <div className="mt-8 space-y-5">
            <div className="flex items-start gap-4">
              <span className="w-11 h-11 rounded-full bg-white/10 grid place-items-center shrink-0">
                <MapPin size={18} className="text-[#F2B441]" />
              </span>
              <div>
                <p className="text-xs uppercase tracking-wider text-white/60">
                  Address
                </p>
                <p
                  data-testid="location-address"
                  className="font-display font-bold text-lg"
                >
                  {RESTAURANT.address}
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <span className="w-11 h-11 rounded-full bg-white/10 grid place-items-center shrink-0">
                <Clock size={18} className="text-[#F2B441]" />
              </span>
              <div>
                <p className="text-xs uppercase tracking-wider text-white/60">
                  Opening hours
                </p>
                <ul className="mt-1 space-y-0.5 text-sm">
                  {RESTAURANT.hours.map((h) => (
                    <li key={h.day} className="flex gap-3">
                      <span className="w-28 text-white/65">{h.day}</span>
                      <span className="font-medium">{h.time}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <a
            href={RESTAURANT.mapsLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="open-in-maps"
            className="mt-8 inline-flex items-center gap-2 bg-[#F2B441] text-[#2C2825] hover:bg-white px-6 py-3 rounded-full font-semibold transition-colors"
          >
            <Navigation size={16} />
            Open in Google Maps
          </a>
        </div>

        <div className="lg:col-span-7 reveal">
          <div className="rounded-3xl overflow-hidden border border-white/10 aspect-[4/3] bg-[#1a1815]">
            <iframe
              data-testid="location-map"
              src={RESTAURANT.mapsEmbed}
              loading="lazy"
              title="Meritz Restaurant location"
              className="w-full h-full"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
